import { SELECIONAR_DATA_IDA } from '../types';

export default function selecionarDataIda (data) {
  return {
    type: SELECIONAR_DATA_IDA,
    payload: data
  }
}
